// Sentry initialization should be imported first!
import './sentry/instrument';

import ReactDOM from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { store, persistor } from './store';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react';

// style + assets
import './assets/scss/style.scss';

// import i18n (needs to be bundled ;))
import './i18n/i18n';

import { NavigatorSetter } from 'NavigatorSetter';

import { isLocalhost } from 'helpers/isLocalhost';
import { logVersion } from 'helpers/logVersion';

import { loadRuntimeConfig } from 'runtimeConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

async function bootstrap() {
  let canRender = true;

  const isLocal = isLocalhost();

  if (!isLocal) {
    try {
      await loadRuntimeConfig();
    } catch (error: any) {
      console.error(error.message ?? error);
      canRender = false;
    }
  }

  if (canRender) {
    logVersion();

    const { default: App } = await import('./App');

    root.render(
      <Provider store={store}>
        <PersistGate
          loading={null}
          persistor={persistor}
        >
          <BrowserRouter>
            <NavigatorSetter />
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>,
    );
  }
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
